import Button from '../../../components/base/Button';

const services = [
  {
    icon: 'ri-home-4-line',
    title: 'Kitchen Remodeling',
    description: 'Complete kitchen renovations with custom cabinets, countertops, and modern appliances. Transform your kitchen into the heart of your home.',
    features: ['Custom Cabinetry', 'Countertop Installation', 'Appliance Integration', 'Lighting Design'],
    image: 'https://public.readdy.ai/ai/img_res/40c7c9e794d1246cce497b0433c4c750.jpg'
  },
  {
    icon: 'ri-drop-line',
    title: 'Bathroom Renovation',
    description: 'Luxury bathroom remodels featuring modern fixtures, elegant tiling, and spa-like amenities for ultimate comfort and relaxation.',
    features: ['Tile Installation', 'Fixture Upgrades', 'Vanity Design', 'Shower Systems'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20bathroom%20renovation%20with%20marble%20tiles%2C%20modern%20vanity%2C%20walk-in%20shower%2C%20contemporary%20fixtures%2C%20natural%20lighting%2C%20clean%20white%20design%2C%20luxury%20finishes%2C%20spacious%20layout&width=600&height=400&seq=bathroom1&orientation=landscape'
  },
  {
    icon: 'ri-building-line',
    title: 'Basement Finishing',
    description: 'Transform unfinished basements into functional living spaces including family rooms, home offices, or entertainment areas.',
    features: ['Flooring Installation', 'Ceiling Systems', 'Electrical Work', 'Moisture Control'],
    image: 'https://readdy.ai/api/search-image?query=Finished%20basement%20renovation%20with%20comfortable%20seating%20area%2C%20modern%20lighting%2C%20laminate%20flooring%2C%20painted%20walls%2C%20entertainment%20center%2C%20cozy%20family%20room%20atmosphere%2C%20professional%20construction&width=600&height=400&seq=basement1&orientation=landscape'
  },
  {
    icon: 'ri-add-box-line',
    title: 'Room Additions',
    description: 'Expand your living space with professionally designed and constructed room additions that seamlessly blend with your existing home.',
    features: ['Foundation Work', 'Structural Design', 'Roofing', 'Interior Finishing'],
    image: 'https://readdy.ai/api/search-image?query=Home%20addition%20construction%20showing%20new%20room%20extension%2C%20professional%20framing%20work%2C%20modern%20architecture%2C%20seamless%20integration%20with%20existing%20house%2C%20quality%20construction%20materials%2C%20bright%20natural%20lighting&width=600&height=400&seq=addition1&orientation=landscape'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Electrical Services',
    description: 'Professional electrical installations and upgrades including panel upgrades, lighting systems, outlets, and complete home rewiring.',
    features: ['Panel Upgrades', 'Lighting Installation', 'Outlet Installation', 'Home Rewiring'],
    image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20working%20on%20electrical%20panel%20installation%2C%20modern%20circuit%20breaker%20box%2C%20electrical%20wiring%2C%20safety%20equipment%2C%20residential%20electrical%20work%2C%20quality%20electrical%20service%2C%20professional%20contractor&width=600&height=400&seq=electrical1&orientation=landscape'
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Plumbing Services',
    description: 'Expert plumbing solutions for repairs, installations, and upgrades including pipes, fixtures, water heaters, and drainage systems.',
    features: ['Pipe Installation', 'Fixture Replacement', 'Water Heater Service', 'Drain Cleaning'],
    image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20installing%20modern%20plumbing%20fixtures%2C%20copper%20pipes%2C%20water%20lines%2C%20quality%20plumbing%20work%2C%20residential%20plumbing%20service%2C%20professional%20tools%2C%20clean%20installation%20work&width=600&height=400&seq=plumbing1&orientation=landscape'
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Project Management',
    description: 'Comprehensive project oversight ensuring timely completion, quality control, and seamless coordination of all trades and materials.',
    features: ['Timeline Management', 'Quality Control', 'Vendor Coordination', 'Progress Reporting'],
    image: 'https://readdy.ai/api/search-image?query=Construction%20project%20management%20scene%20with%20blueprints%2C%20hard%20hats%2C%20measuring%20tools%2C%20professional%20contractor%20reviewing%20plans%2C%20organized%20work%20site%2C%20quality%20control%20inspection%2C%20modern%20construction&width=600&height=400&seq=management1&orientation=landscape'
  }
];

export default function ServicesSection() {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our <strong>Remodeling Services</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From concept to completion, we provide comprehensive home remodeling services with expert craftsmanship and professional project management.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-48">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-blue-600 text-white p-3 rounded-lg">
                  <i className={`${service.icon} text-2xl`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {service.description}
                </p>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <Button 
                  variant="outline"
                  size="sm"
                  onClick={scrollToQuote}
                  className="w-full"
                >
                  Get Quote
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
